const wikiMobileNav = document.getElementById('wiki-mobile-nav');

function initWikiMobileNav() {

	function init() {
		addEventListeners();
	}

	function addEventListeners() {
		wikiMobileNav.addEventListener('change', switchWikiPage );
	}

	function switchWikiPage(e) {
		e.preventDefault();

		const value = e.target.value;

		window.location.href = value;
	}

	init();
	
}

if ( wikiMobileNav ) {
	initWikiMobileNav();
}